<template>
    <v-content :style="{'background-image': `url('`+ require('../assets/bg-login.jpg') +`')`}"
               style="background-size: cover">
        <!-- Header -->
        <Header></Header>
        <!-- Menu -->
        <v-layout justify-center>
            <v-flex xs12 style="background-color: #527281">
                <v-content>
                    <v-layout px-12 py-3>
                        <v-flex shrink style="text-align: left;">
                            <v-btn text small style="color: white;font-size: 18px" @click="$router.push('/home').catch(err => {})">
                                หน้าแรก
                            </v-btn>
                        </v-flex>
                        <v-icon style="color: white">play_arrow</v-icon>
                        <v-flex shrink style="text-align: left;">
                            <v-btn text small style="color: white;font-size: 18px">ช่วยเหลือ</v-btn>
                        </v-flex>
                    </v-layout>
                </v-content>
            </v-flex>
        </v-layout>
        <!-- Detail -->
        <v-layout>
            <v-flex class="my-12">
                <v-layout>
                    <v-flex xs7 style="text-align: right" class="offset-2">
                        <span class="" style="font-size: 36px; color: #D97C57;font-weight: bold">ปัญหาที่พบบ่อย?</span>
                    </v-flex>
                    <v-flex xs5 class="offset-1">
                        <v-btn style="background-color: #84A2A8; color: white;border-radius: 25px;" @click="dialog = false">ดาวน์โหลดคู่มือการใช้งาน</v-btn>
                    </v-flex>
                </v-layout>
                <v-layout justify-center>
                    <v-flex xs10 class="py-6" style="background-color: #527281">
                    </v-flex>
                </v-layout>
                <v-layout justify-center>
                    <v-flex xs10>
                        <v-card class="pb-12 pt-4">
                                <v-layout justify-center v-for="item in qa">
                                    <v-flex xs9 class="my-4 pa-6" style="background-color: #EEEEEE;border-radius: 20px">
                                        <v-row>
                                            <v-col cols="md-2" class="py-0 px-6" style="text-align: right;">
                                                <span class="px-3 py-1" style="background-color: #527281; border-radius: 20px;color: white;font-weight: bold">{{item.no}}</span>
                                            </v-col>
                                            <v-col class="pa-0">
                                                <v-flex style="background-color: #EEEEEE;text-align: left;">
                                                    <v-layout>
                                                        <v-flex style="font-weight: bold; color: #527281;">
                                                            {{item.question}}
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout>
                                                        <v-flex style="color: #527281;">
                                                            {{item.amswer}}
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-col>
                                        </v-row>
                                    </v-flex>
                                </v-layout>
                        </v-card>
<!--                        <pagination></pagination>-->
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex class="py-6" style="background-color: white">
            </v-flex>
        </v-layout>
        <!-- Footer -->
        <Footer></Footer>
    </v-content>
</template>

<script>
    import Header from "../components/Header";
    import Footer from "../components/Footer";
    import Pagination from "../components/Pagination";

    export default {
        name: "Help",
        components: {
            Footer,
            Header,
            Pagination
        },
        data: () => ({
            qa: [
                {no:'1.',question:'Q : ลงทะเบียนไม่สำเร็จ?', amswer:'A : ติดต่อกรมการแพทย์ทหารบก 02-354-4422'},
                {no:'2.',question:'Q : ลืมรหัสผ่าน?', amswer:'A : กดคลิกที่ ลืมรหัสผ่าน? ในหน้าลงทะเบียน ทำตามขั้นตอน และกำหนดรหัสผ่านใหม่'},
                {no:'3.',question:'Q : บัญชีขึ้นสถานะ ระงับการใช้งาน?', amswer:'A : ติดต่อกรมการแพทย์ทหารบก 02-354-4422'},
                {no:'4.',question:'Q : ให้จดจำรหัสผ่านตลอดไป?', amswer:'A : ติ๊กเลือก จำฉันไว้? ในหน้าลงชื่อเข้าใช้งาน ระบบจะจำอีเมล และรหัสอัตโนมัติ เมื่อมีการเข้าใช้งาน'},
            ]
        })
    }
</script>

<style scoped>

</style>
